module.exports = __webpack_public_path__ + "static/media/1.5261aba1.png";